var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tableDiv"},[_c('h4',[_vm._v("Derived Fatty Acid Data")]),_vm._v(" "),_c('table',{staticClass:"table",staticStyle:{"width":"100%"},attrs:{"id":"DerivedFattyAcidTable"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef7ad63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Palm/PalmDerivedData/DerivedFattyAcidTable.vue
// module id = null
// module chunks = 